if (typeof QuickView === "undefined") {
  const { FoxThemeStyles, FoxThemeScripts } = window;
  class QuickView {
    constructor() {
      this.quickChange()
      this.modal = null;

      addEventDelegate({
        selector: "[data-product-quickview]",
        handler: (e, target) => {
          e.preventDefault();
          this.target = target;
          target.classList.add("btn--loading");
          const productHandle = target.dataset.productQuickview;    
          var isUpdate = target.classList.contains('quick-update');
          var size = null;
          var cartVariant = null;
          if(target.dataset.size != undefined){
             size = target.dataset.size;
          }
          if(target.dataset.variantId){
            cartVariant = target.dataset.variantId;
          }
          if (productHandle) this.fetchHtml(productHandle,size,cartVariant,isUpdate);
        },
      });

      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (this.modal) this.modal.hide();
      });
    }
    quickChange() {
      const prefetchCache = {};
      const fetchPromises = {};
      
      // Prefetch quick view content on swatch hover
      document.body.addEventListener("mouseover", async (event) => {
        const swatch = event.target.closest(".quick-view-swatch");
        if (!swatch) return;
      
        const handle = swatch.dataset.handle;
        if (!handle || prefetchCache[handle] || fetchPromises[handle]) return;
      
        const url = `${window.FoxThemeSettings.base_url}products/${handle}?section_id=product-quickview`;
      
        fetchPromises[handle] = fetch(url)
          .then((res) => res.text())
          .then((html) => {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;
            const modal = tempDiv.querySelector("modal-dialog");
            if (modal) {
              prefetchCache[handle] = modal.innerHTML;
            }
            delete fetchPromises[handle];
          })
          .catch((err) => {
            console.error("Prefetch error:", err);
            delete fetchPromises[handle];
          });
      });
      
      // Replace content on swatch click
      document.body.addEventListener("click", async (event) => {
        const swatch = event.target.closest(".quick-view-swatch");
        if (!swatch) return;
      
        event.preventDefault();
      
        const parent = event.target.closest("a");
        const href = parent?.getAttribute("href");
        if (!href) return;
      
        const parts = href.split("/");
        const handle = parts[parts.length - 1] || parts[parts.length - 2];
      
        const existingModal = document.querySelector("modal-dialog.f-modal-quickview");
        if (!existingModal) return;
      
        const getHtml = async () => {
          if (prefetchCache[handle]) return prefetchCache[handle];
      
          const url = `${window.FoxThemeSettings.base_url}products/${handle}?section_id=product-quickview`;
          const html = await fetch(url).then((res) => res.text());
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;
          const modal = tempDiv.querySelector("modal-dialog");
          return modal?.innerHTML || "";
        };
      
        const htmlContent = await getHtml();
      
        if (htmlContent) {
          
          var oldCardItem = existingModal.querySelector('#ProductSubmitButton-product-quickview[name="add"]').dataset.cartId;
          existingModal.innerHTML = htmlContent;
          var hasUpdateClass = existingModal.classList.contains('is-update-modal');
          var oldSize = existingModal.dataset.size;
          // console.log('oldSoize',oldSize)
          setTimeout(()=>{
            if(oldSize != null){             
              existingModal.querySelector(`input[value='${oldSize}']`).setAttribute("checked", true);
              existingModal.querySelector(`input[value='${oldSize}']`).classList.add('size-selected');      
            }
          },100)
          if(hasUpdateClass){
            existingModal.querySelector('#ProductSubmitButton-product-quickview[name="add"] span').textContent = 'update'
          }
          if(oldCardItem != undefined && oldCardItem != ''){
            existingModal.querySelector('#ProductSubmitButton-product-quickview[name="add"]').setAttribute('data-cart-id',oldCardItem)
          }
      
          // Re-add swatch click handler
          existingModal.querySelectorAll('.swatch__button a').forEach((el) => {
            el.classList.add('quick-view-swatch');
          });
      
          // Optional: Add class for styling purposes
          existingModal.querySelector('.f-modal__content')?.classList.add('new-modal');
      
          // Reinitialize features if needed
          loadAssets(
            [
              FoxThemeScripts.productInfo,
              FoxThemeScripts.productMedia,
              FoxThemeScripts.variantsPicker,
              FoxThemeScripts.volumePricing,
            ],
            "variants-picker",
            () => {
              // Optionally trigger modal behavior
              existingModal.show?.();
              const mediaGallery = existingModal.querySelector("media-gallery");
              if (mediaGallery?.update) mediaGallery.update();
      
              if (Shopify?.PaymentButton) {
                Shopify.PaymentButton.init();
              }
      
              __reInitTooltip(existingModal);
            }
          );
        }
      });

    }




    fetchHtml(productHandle,size,cartVariant,isUpdate) {
      loadAssets(
        [FoxThemeStyles.product, FoxThemeStyles.volumePricing],
        "quick-view-assets"
      );
      fetchSection("product-quickview", {
        url: `${window.FoxThemeSettings.base_url}products/${productHandle}`,
      })
        .then((html) => {
          this.modal = html.querySelector("modal-dialog");
          this.modal.querySelectorAll('.swatch__button a').forEach((swatch)=>{
            swatch.classList.add('quick-view-swatch')
          })
          const firstModel = html.querySelector("product-model");
          this.mediaGallery = this.modal.querySelector("media-gallery");
          this.swiperMedia = this.modal.querySelector("swiper-media-gallery");
          document.body.appendChild(this.modal);    
          setTimeout(()=>{
            // console.log('sizechart call')
           if(document.body.classList.contains('template-product')){
              if (wrapper && wrapper.hasChildNodes()) {
                // console.log('Element has child nodes.');
              } else {
                // console.log('Element has no child nodes.');
                addCustomButtons()
              }
          }
          },500)      
          if(isUpdate){
            this.modal.classList.add('is-update-modal')
            this.modal.querySelector(`button[type='submit'] span`).textContent = 'Update'
          }
          if(cartVariant != null && cartVariant != undefined){
            this.modal.setAttribute('data-variant-id',cartVariant) 
            this.modal.querySelector(`button[type='submit']`).setAttribute('data-cart-id',cartVariant)  
          }
          setTimeout(()=>{
            if(size != null){
              this.modal.setAttribute('data-size',size)
              this.modal.classList.add('quick-update')                 
              this.modal.querySelector(`input[value='${size}']`).setAttribute("checked", true);
              this.modal.querySelector(`input[value='${size}']`).classList.add('size-selected');      
            }
          },100)
          loadAssets(
            [
              FoxThemeScripts.productInfo,
              FoxThemeScripts.productMedia,
              FoxThemeScripts.variantsPicker,
              FoxThemeScripts.volumePricing,
              FoxThemeScripts.productMedia,
            ],
            "variants-picker",
            () => {
              this.modal && this.modal.show(this.target);
              if(this.swiperMedia){
                this.swiperMedia.update();
              }
              if (this.mediaGallery) {
                const thumb = this.mediaGallery.querySelector(
                  '[id^="GalleryThumbnails"]'
                );
                if (thumb) thumb.update();
                this.mediaGallery.update();
              }
              if (Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
              this.target.classList.remove("btn--loading");
              this.handleClose();
              this.toolTip = __reInitTooltip(this.modal);
            }
          );
          if (firstModel) {
            loadAssets(
              [
                FoxThemeScripts.productModel,
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
              ],
              "product-model-assets"
            );
          }
        })
        .catch(console.error);
    }

    handleClose() {
      if (!this.modal) return;
      this.modal.addEventListener("close", () => {
        const allTooltip = [
          ...(this.modal.querySelector("product-info")?.toolTip || []),
          ...(this.toolTip || []),
        ];
        allTooltip.forEach((item) => item.unmount());

        const quantityInputs = this.modal.querySelectorAll("quantity-input");
        quantityInputs.forEach((input) => {
          input.disconnectedCallback();
        });

        this.modal.remove();
      });
    }
  }
  new QuickView();
  window.QuickView = QuickView;
}
